import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PopUp } from '@components';

import styles from '../../../OrderStatusPage.module.scss';

interface UnsubscribeModalProps {
  label: string;
  unsubscribe: () => void;
  close: () => void;
}

export const UnsubscribeModal: FC<UnsubscribeModalProps> = ({
  label,
  unsubscribe,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <PopUp
      onClick={unsubscribe}
      onClose={close}
      buttonText={t('orderStatus.notification.buttonYes')}
    >
      <p className={styles.orderStatusPageFormDescription}>
        {t('orderStatus.notification.unsubscribeDesc', { label })}
      </p>
    </PopUp>
  );
};
